import React from 'react'
import {observer} from 'mobx-react-lite'
import {Box, Flex, Stack, Text} from '../../../vanilla'
import {useProductStore} from '../../../store/hooks/useStore'
import {cartItemDetails, cartItemDetailsName, cartItemImage} from './styles.css'
import {Link} from '../../../components/link'
import {formatProductName} from '../../../utils/utils'
import {ProductImage} from '../../../components/product-detail/product-image'

interface OrderEditRemovedCartItemProps {
  productId: string
}

const OrderEditRemovedCartItemContainer = ({productId}: OrderEditRemovedCartItemProps) => {
  const {productsById} = useProductStore()
  const product = productsById[productId]

  if (!product) return null

  const productLink = `/p/${formatProductName(product?.name)}/${product?.id}.html`

  // @todo format the algolia data to be consistent across PLP and PDP
  const img = product.image_groups?.[0]?.images?.[0] || product.imageGroups?.[0]?.images?.[0]

  return (
    <Flex
      padding="16px"
      style={{background: '#cc092f08'}}
      justify="space-between"
      flexWrap="wrap"
      borderBottom="1px"
      borderColor="gray200"
      paddingBottom={['0px', '16px']}
    >
      <Box
        as={Link}
        href={productLink}
        ratio="1"
        width="full"
        flexShrink="0"
        position="relative"
        className={cartItemImage}
        marginBottom="16px"
      >
        <ProductImage 
          image={img}
          imageAlt={img?.alt}
          isThumbnail={true}
          inDrawer={false}
          display="block"
          width="full"
          height="auto"
          minHeight={['auto', 'full']}
          style={{objectFit: 'contain'}}      
        />
      </Box>
      <Box className={cartItemDetails} alignSelf="flex-start">
        <Stack spacing="0px">
          <Text
            as={Link}
            color={{default: 'gray800', hover: 'gray700'}}
            to={productLink}
            variant="text3"
            lineHeight="short"
            className={cartItemDetailsName}
          >
            {product.name}
          </Text>
        </Stack>
      </Box>
      <Box marginRight="44px" alignSelf="center">
        <Text variant="text3" color="accent0" data-test-selector="product-removed-label">
          Product Removed
        </Text>
      </Box>
    </Flex>
  )
}
export const OrderEditRemovedCartItem = observer(OrderEditRemovedCartItemContainer)
